import { cn } from '@/lib/utils';

interface PageContainerProps {
  children: React.ReactNode;
  className?: string;
}

export function PageContainer({ children, className }: Readonly<PageContainerProps>) {
  return (
    <div className={cn('mx-auto max-w-[28rem] px-4 py-6 lg:max-w-5xl', className)}>{children}</div>
  );
}
